"use client";

import { useCallback, useRef, type ComponentType } from "react";

import { HomeGraphicShell } from "./home-graphic-shell";
import { preloadImages } from "./preload";

type SceneProps = { play: boolean };

export function CtaGraphic() {
	const sceneRef = useRef<ComponentType<SceneProps> | null>(null);

	const onApproach = useCallback(async () => {
		const mod = await import("./cta-scene");
		await preloadImages(mod.CTA_COIN_PRELOAD);
		sceneRef.current = mod.CtaScene;
	}, []);

	return (
		<HomeGraphicShell
			width={652.716}
			height={454.162}
			roundedClassName="rounded-2xl"
			onApproach={onApproach}
		>
			{({ play, ready }) => {
				const Scene = sceneRef.current;
				return ready && Scene ? <Scene play={play} /> : null;
			}}
		</HomeGraphicShell>
	);
}
